(() => {
  if (!customElements.get('drawer-opener')) {
    class DrawerOpener extends HTMLElement {
      constructor() {
        super();
    
        const button = this.querySelector('button');
    
        if (!button) return;
    
        button.addEventListener('click', (event) => {
          this.onButtonClick(button);
        });
      }
    
      onButtonClick(button) {
        const drawer = document.querySelector(
          this.getAttribute('data-drawer')
        );
    
        if (drawer) drawer.show(button);
      }
    }

    customElements.define('drawer-opener', DrawerOpener);
  }


  if (!customElements.get('slide-out-drawer')) {
    class Drawer extends HTMLElement {
      constructor() {
        super();

        this.dialogHolder = this.querySelector('[role="dialog"]');
        this.querySelectorAll('[id^="ModalClose-"]').forEach(button => {
          button.addEventListener('click', this.hide.bind(this, false));
        });
        this.addEventListener('keyup', event => {
          if (event.code?.toUpperCase() === 'ESCAPE') this.hide();
        });
        this.addEventListener('click', event => {
          if (event.target === this) this.hide();
        });
      }

      connectedCallback() {
        if (this.moved) return;
        this.moved = true;
        document.body.appendChild(this);
      }

      show(opener) {
        this.openedBy = opener;
        this.setAttribute('open', '');
        this.dialogHolder.addEventListener(
          'transitionend',
          () => {},
          { once: true }
        );
        bodyScroll.lock(this.dialogHolder);
      }

      hide() {
        if (this.hasAttribute('data-remove')) {
          const transitionDisabled = window
            .getComputedStyle(this, null)
            .getPropertyValue('transition')
            .includes('none');
          if (transitionDisabled) {
            this.remove();
          } else {
            this.addEventListener(
              'transitionend',
              () => {
                this.remove();
              },
              { once: true }
            );
          }
        }
        document.body.dispatchEvent(new CustomEvent('modalClosed'));
        this.removeAttribute('open');
        bodyScroll.unlock(this.dialogHolder);
      }
    }

    customElements.define('slide-out-drawer', Drawer);
  }
})();

